import React, { useState } from "react";
import axios from "axios";
import { API } from "@/App";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Link, useNavigate } from "react-router-dom";
import "./Auth.css";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleResetRequest = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await axios.post(`${API}/auth/request-reset`, { email });

      toast.success(
        "If this email exists, a password reset link has been sent."
      );

    } catch (error) {
      toast.error("Something went wrong. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="glass-background"></div>

      {/* ⭐ NAVBAR WITH LOGO */}
      <nav className="auth-nav fade-in">
        <div className="nav-brand" onClick={() => navigate('/')}>
          <img src="/icons/logo-512.png" alt="GrammAA Logo" className="nav-logo" />
          <span className="brand-text">GrammAA</span>
        </div>
      </nav>

      <div className="auth-box glass-panel glow-effect fade-in">
        <div className="auth-header">
          <h1>Reset Password</h1>
          <p>Enter your email to receive a reset link</p>
        </div>

        <form onSubmit={handleResetRequest} className="auth-form">

          {/* EMAIL */}
          <div className="form-group">
            <Label htmlFor="email">Email</Label>
            <Input
              id="email"
              type="email"
              placeholder="your@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="glass-input"
            />
          </div>

          <Button
            type="submit"
            disabled={loading}
            className="glass-btn auth-submit-btn"
          >
            {loading ? "Sending..." : "Send Reset Link"}
          </Button>
        </form>

        <div className="auth-footer">
          <p>
            Remember your password?{" "}
            <Link to="/login" className="auth-link">
              Back to Login
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
